module.exports = __webpack_public_path__ + "img/ico-plus-yellow.847f802d.svg";